// Built-in tours authored in code, by registry section key. A section with
// none here gets its "Around <section>" tour from the registry
// (tourFromSection): a step per feature, outlining its first control.
import type { HelpReader } from '../features'
import type { TourRun } from '../tourRuntime'
import { tablesTour } from './tables'

export const BUILT_IN_TOURS: Record<string, (reader: HelpReader) => TourRun> = {
  tables: tablesTour,
}
